const ErrorMessageBox = (props: any) => {

  let errorMessage = props.errorMessage;
  return (
    <>
      {(errorMessage) &&
        <div className="DangerError text-center mt-3">
          {errorMessage}
        </div>
      }
    </>
  )
}

export default ErrorMessageBox